import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { List, Map } from 'immutable';
import { pageContext } from 'ctm-util-functions';

import { FeaturesList } from './features_list/features_list';
import styles from './features_column.css';

/**
 * @todo here's where I envision we will handle per column animations
 * A features column component that logically separates a 'column' in the results features mode and pairs and features
 * header component with an appropriate features list component
 */
class _FeaturesColumn extends Component {

    constructor(props) {
        super(props);

        this.state = {
            callToggle: false,
            callBackToggle: false
        };
    }

    /**
     * Don't re-render unless callBackSuccess has changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render
     */
    shouldComponentUpdate = (nextProps, nextState) => {
        const { callBackSuccess } = this.props;
        const { callToggle, callBackToggle } = this.state;
        return nextProps.callBackSuccess !== callBackSuccess
            || nextState.callToggle !== callToggle
            || nextState.callBackToggle !== callBackToggle;
    };

    // @todo future refactor when more use cases for maintaining state at this row level are required
    /**
     * All events that the results listens for must be defined here.
     * All child components rendered receive the event handler and can change state of the results
     * Callback functions must pass an object with at least an id key. e.g. { id: 'call, extraArgs: ... }
     * @param {object} type - the callback arguments
     * @param {object} proxy - the react proxy event object
     * @param {object} event - standard javascript event object
     */
    eventHandler = (type, proxy, event) => {
        switch (type.id) {
            case 'call':
                this.setState((state) => ({ callToggle: !state.callToggle, callBackToggle: false }));
                break;
            case 'callBack':
                this.setState((state) => ({
                    callToggle: false,
                    callBackToggle: !state.callBackToggle
                }));
                break;
            // case 'pinnedProduct':
            //     // eg set state the allows boreder to be applied to the row
            //     break;
            default:
                // eslint-disable-next-line no-console
                console.error(`No event handler defined for event type ${type.id}`);
        }
    };

    /**
     * Lifecycle method to update state for new props
     * @param {Object} nextProps - The incoming set of props
     */
    componentWillReceiveProps = (nextProps) => {
        const { callBackToggle } = this.state;
        if (nextProps.callBackSuccess && callBackToggle) {
            const visibility = !nextProps.callBackSuccess;
            this.setState({
                callBackToggle: visibility
            });
        }
    };

    renderFeatureHeader() {
        const { quote, filteredQuotes, unavailableBrands, headerLayout } = this.props;
        const { constructComponents } = pageContext.getProps().director;
        const stateProps = {
            product: quote,
            eventHandler: this.eventHandler,
            ...this.state
        };

        if (quote !== undefined) {
            return constructComponents([headerLayout], { stateProps });
        } if (filteredQuotes !== undefined) {
            return constructComponents(
                ['component_featuresHeaderFilteredProductsList'],
                { filteredQuotes }
            );
        } if (unavailableBrands !== undefined) {
            return constructComponents(
                ['component_featuresHeaderNotAvailableList'],
                { unavailableBrands }
            );
        }
        return null;
    }

    renderFeaturesList() {
        const { quote, index, isLabels, fullWidthLabels, numberOfQuotes, columnsPerPage } = this.props;
        if (quote !== undefined) {
            return (
                <FeaturesList
                    quote={quote}
                    isLabels={isLabels}
                    fullWidthLabels={fullWidthLabels}
                    index={index}
                    numberOfQuotes={numberOfQuotes}
                    columnsPerPage={columnsPerPage}
                />
            );
        }
        return null;
    }

    /**
     * Pairs a features header component with a features list component within it's own column
     * The headerLayout is a layout which will be rendered within the featured header
     * isLabels determines whether to render the feature list as 'labels' or not
     * @returns {Node} - the features column component with header and list
     */
    render = () => {
        const {
            id,
            isLabels
        } = this.props;
        const cx = classNames.bind(styles);

        return (
            <div className={cx({ featuresQuote: true, animated: !isLabels })} id={id}>
                {this.renderFeatureHeader()}
                {this.renderFeaturesList()}
            </div>
        );
    };

}

_FeaturesColumn.propTypes = {
    id: PropTypes.string,
    quote: PropTypes.instanceOf(Map),
    unavailableBrands: PropTypes.instanceOf(List),
    filteredQuotes: PropTypes.instanceOf(List),
    isLabels: PropTypes.bool,
    headerLayout: PropTypes.string,
    fullWidthLabels: PropTypes.bool,
    numberOfQuotes: PropTypes.number,
    columnsPerPage: PropTypes.number,
    index: PropTypes.number,
    callBackSuccess: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    const callBackSuccess = state.getIn(['page', 'callBackSuccess']);
    return {
        callBackSuccess
    };
};

const FeaturesColumn = connect(mapStateToProps)(_FeaturesColumn);
export { _FeaturesColumn, FeaturesColumn };
